import { CanDeactivateFn } from '@angular/router';
import { Observable } from 'rxjs';
import { CanComponentDeactivate } from '@umss/shared/utils';

export const canDeactivateGuard: CanDeactivateFn<CanComponentDeactivate> = (
  component: CanComponentDeactivate
): Observable<boolean> | Promise<boolean> | boolean => {
  return component.canDeactivate ? component.canDeactivate() : true;
};
